import { Dispatch, SetStateAction } from 'react';
import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { useMultiStepModal } from '@frontend/payments-multistep-modal';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { Modal } from '@frontend/design-system';
import { BULK_CREATE_STEPS } from '../bulk-create-steps-key-title';
import { Filters } from '../filters/filters';
import { useFilters } from '../filters/use-filters';
import { styles } from './styles';
import { DesktopList } from './validate-users-step/desktop-list';
import { Footer } from './validate-users-step/footer';
import { MobileList } from './validate-users-step/mobile-list';

type ValidateUsersStepProps = {
  patients: GetPatientsBalanceResponse_PatientBalance[];
  onSelectionChange: Dispatch<SetStateAction<Record<string, boolean>>>;
  selected: Record<string, boolean>;
};
export const ValidateUsersStep = ({ patients, onSelectionChange, selected }: ValidateUsersStepProps) => {
  const { goToStep, closeModal } = useMultiStepModal();
  const isMobile = useMatchMedia({ maxWidth: breakpoints.xsmall.max });
  const { data: filteredPatients, handleFilterChange } = useFilters(patients);

  return (
    <>
      <Modal.Body css={styles.modalBody(true)}>
        <Filters onChange={handleFilterChange} hideLocation={isMobile} />
        {isMobile ? (
          <MobileList patients={filteredPatients} selected={selected} onSelectionChange={onSelectionChange} />
        ) : (
          <DesktopList patients={filteredPatients} onSelectionChange={onSelectionChange} selected={selected} />
        )}
      </Modal.Body>
      <Footer
        closeModal={closeModal}
        selectedCount={Object.values(selected).filter(Boolean).length}
        onTextToPayClick={() => {
          goToStep(BULK_CREATE_STEPS.SEND_SMS.id);
        }}
      />
    </>
  );
};
